import type { PlanTypes } from '@gonfalon/billing/types';

import { isDeveloperPlanFacade } from '../internal/plan/isDeveloperPlanFacade';

import { isFoundationPlan } from './isFoundationPlan';
import { planIdToPlan } from './planData';

/**
 * Check if a plan is an actual Foundation plan (Foundation2023 or Foundation2025).
 * This excludes the legacy Developer plan facade, which is treated as Foundation for payment UI
 * but should not be included in Foundation-specific logic like customize commits flow.
 */
export const isFoundationPlanNotFacade = (planType: PlanTypes | null | undefined): boolean => {
  if (!planType) {
    return false;
  }

  const plan = Object.values(planIdToPlan).find((p) => p.planType === planType);
  if (!plan) {
    return false;
  }

  return isFoundationPlan(planType) && !isDeveloperPlanFacade(plan);
};
